module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0085.jpg?v=ec4e23e3";